export const shimmerSx = {
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    zIndex: 0,
    background: "linear-gradient(100deg, transparent 20%, rgba(255,255,255,0.08) 45%, transparent 70%)",
    backgroundSize: "220% 100%",
    animation: "cardShimmer 1.4s linear infinite",
    pointerEvents: "none",
  },
  "&[data-loaded='true']::before": { display: "none" },
  "@keyframes cardShimmer": {
    from: { backgroundPosition: "120% 0" },
    to: { backgroundPosition: "-120% 0" },
  },
  "@media (prefers-reduced-motion: reduce)": { "&::before": { animation: "none" } },
};

export const fadeInImageSx = {
  opacity: 0,
  transition: "opacity 0.35s ease",
  "[data-loaded='true'] > &": { opacity: 1 },
  "@media (prefers-reduced-motion: reduce)": { transition: "none" },
};
